import { IllustrationType } from '@/components/illustration/helpers';

export interface ErrorContent {
  illustration: IllustrationType;
  title: string;
  content: string;
  showHomeButton: boolean;
}

export const DEFAULT_ERROR_CONTENT: ErrorContent = {
  illustration: 'server-error',
  title: 'Unexpected Error',
  content: 'There was an unexpected error. Please try again later.',
  showHomeButton: true,
};

export const ErrorContentMap: Map<number, ErrorContent> = new Map();
ErrorContentMap.set(403, {
  illustration: 'user-access',
  title: 'Not Approved for Access',
  content:
    'Your user account is not approved for access to the admin site. Please contact IT support if you require access.',
  showHomeButton: false,
});
ErrorContentMap.set(500, {
  illustration: 'restricted-access',
  title: 'Authentication Error',
  content:
    'There was an unexpected error while authenticating your account. Please try again later.',
  showHomeButton: true,
});
